module.exports = __webpack_public_path__ + "img/icon_car.06e2cc3a.svg";